import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetStatesMedicalGuide,
	GetStatesMedicalGuideModel,
	GetStatesMedicalGuideParams,
} from 'domain/usecases';

export class RemoteGetStatesMedicalGuide implements GetStatesMedicalGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetStatesMedicalGuideModel>,
	) {}

	async get({
		signal,
		...params
	}: GetStatesMedicalGuideParams): Promise<GetStatesMedicalGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
